import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from './_services/authentication.service';
import { UserService } from './_services/user.service';
import { AlertComponent } from './_directives/alert.component';
import { LoginCustom } from './_helpers/login-custom';
import { TokenResponseModel } from './_models/Response/TokenResponseModel';
import { UserForgetPasswordRequestModel } from './_models/Request/UserForgetPasswordRequestModel';
import { ScriptLoaderService } from '@global-services/script-loader.service';
import { GetReCaptchaResponseModel } from './_models/Response/GetReCaptchaResponseModel';
import { ResponseModel } from '@global-models/Response/ResponseModel';
import { TokenRequestModel } from './_models/Request/TokenRequestModel';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AlertService } from '@shared-services/alert.service';
import { AppHelper } from '@shared-helpers/app-helper';

@Component({
  selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
  templateUrl: './templates/login-1.component.html',
  styleUrls: ['./templates/login.css'],
  encapsulation: ViewEncapsulation.None,
})

export class AuthComponent implements OnInit {
  model: any = {};
  loading = false;
  returnUrl: string;
  SendMailStatus = 0; /* 0 - Mail Girişi | 1- Email den gelen Key girişi | 2- Şifre değiştirme */
  captchaCode = '';
  captchaText = '';
  public passwordChangeGuid: string;
  public forgetModel = new UserForgetPasswordRequestModel;
  public Logo: string;
  public year: number;
  public counterInterval = 60;
  public kvkkText: string;
  public kvkkLink: string;
  public vbtText: string;
  public vbtLink: string;
  public contactLink: string;
  public contactText: string;
  public buttonText: string;
  public authenticationStatus = false;

  @ViewChild('alertSignin', { read: ViewContainerRef }) alertSignin: ViewContainerRef;
  @ViewChild('alertSignup', { read: ViewContainerRef }) alertSignup: ViewContainerRef;
  @ViewChild('alertForgotPass', { read: ViewContainerRef }) alertForgotPass: ViewContainerRef;
  @ViewChild('CancelForget') cancelForget: ElementRef;
  @ViewChild('ChangePasswordButton') changePasswordButton: ElementRef;

  constructor(
    private _router: Router,
    private _script: ScriptLoaderService,
    private _userService: UserService,
    private _route: ActivatedRoute,
    private _authService: AuthenticationService,
    private _alertService: AlertService,
    private cfr: ComponentFactoryResolver) {

    var passwordForgotGuid = this._route.snapshot.queryParams['forgotpassword'];
    if (!AppHelper.IsNullOrUndefined(passwordForgotGuid)) {
      if (AppHelper.IsValidGuid(passwordForgotGuid)) {
        this.SendMailStatus = 1;
        this.passwordChangeGuid = passwordForgotGuid;
        this.forgetModel.EmailCode = this.passwordChangeGuid;

      }
    }
  }


  ngOnInit() {
    this.model.remember = true;
    if (environment.Key === 'SANKOTEST' || environment.Key === 'SANKOPROD') {
      this.Logo = './assets/app/media/img/logos/sankoSiyahLogo.png';
    } else if (environment.Key === 'VBTPROD' || environment.Key === 'VBTTEST' || environment.Key === 'VBTLOCAL' || environment.Key === 'VBTCUSTOM') {
      this.kvkkText = "KVKK Aydınlatma Metni";
      this.kvkkLink = "https://www.vbt.com.tr/sayfa/kisisel-verilerin-korunmasi";
      this.vbtText = "VBT";
      this.vbtLink = 'https://www.vbt.com.tr/';
      this.contactText = "İletişim";
      this.contactLink = 'https://www.vbt.com.tr/sayfa/iletisim';
      this.Logo = './assets/app/media/img/logos/logo-5.svg';
    }
    else {
      this.Logo = './assets/app/media/img/logos/logo-5.svg';

    }

    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
    this._router.navigate([this.returnUrl]);

    this._script.loadScripts('body', [
      'assets/vendors/base/vendors.bundle.js',
      'assets/demo/default/base/scripts.bundle.js',
      'assets/demo/default/custom/components/base/dropdown.js',
      'assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js'], true).then(() => {
        LoginCustom.init();
      });
    this.captchaCode = (localStorage.getItem('Captcha') === null) ? null : JSON.parse(localStorage.getItem('Captcha')).captchaCode;
    if (!AppHelper.IsNullOrUndefined(this.passwordChangeGuid)) {
      // this.changePasswordButton.nativeElement.click();
      this.OpenPasswordFields();
    }

  }

  SignInOTP() {
    if (AppHelper.IsNullOrUndefined(this.model.code)) {
      let alertMessage = "Doğrulama Kodu Dolu Olmalıdır!"
      this.showAlert('alertSignin');
      // this._alertService.error(alertMessage);
      this._alertService.showErrorMessage(alertMessage);
    }
    else {
      this.signin();
    }
  }

  signin() {
    this.loading = true;
    const tokenmodel = new TokenRequestModel();
    tokenmodel.Password = this.model.password;
    tokenmodel.Email = this.model.username;
    tokenmodel.Code = this.model.code;
    tokenmodel.FirmId = 0;
    tokenmodel.CaptchaKey = (localStorage.getItem('Captcha') === null) ? undefined : JSON.parse(localStorage.getItem('Captcha')).CaptchaKey;
    tokenmodel.CaptchaText = this.captchaText;

    this._authService.login(tokenmodel)
      .then(data => {
        const token = (data as TokenResponseModel);
        if (token.AuthenticationType !== 'None' && !AppHelper.IsNullOrUndefined(token.AuthenticationType)) {
          this.authenticationStatus = true;
          this.SecurityCodeCountdown();
          return;
        }
        if (!AppHelper.IsNullOrUndefined(token)) {
          this.captchaCode = token.CaptchaImage;

          localStorage.setItem('Captcha', JSON.stringify({ 'CaptchaKey': token.CaptchaKey, 'captchaCode': this.captchaCode }));

          if (!AppHelper.IsNullOrUndefined(token.Token)) {
            this._router.navigate([this.returnUrl]);
          }
          else {
            this.captchaText = '';
            let alertMessage = token.ErrorType;
            if (AppHelper.IsNullOrEmpty(alertMessage)) {
              alertMessage = 'Giriş yapılamadı.';
            }
            this.showAlert('alertSignin');
            // this._alertService.error(alertMessage);
            this._alertService.showErrorMessage(alertMessage);
            this.loading = false;
          }
        }
      },
        error => {
          this.showAlert('alertSignin');
          // this._alertService.error(error);
          this._alertService.showErrorMessage(error);
          this.loading = false;
        }).catch(error => {
          this.showAlert('alertSignin');
          // this._alertService.error(error);
          this._alertService.showErrorMessage(error);
          this.loading = false;
        });
  }

  showAlert(target) {
    this[target].clear();
    const factory = this.cfr.resolveComponentFactory(AlertComponent);
    const ref = this[target].createComponent(factory);
    ref.changeDetectorRef.detectChanges();
  }

  PasswordForget() {
    this.SendMailStatus = 0;
    this.forgetModel = new UserForgetPasswordRequestModel();
  }

  PasswordChangeClick() {
    if (this.SendMailStatus === 0) {
      if (!AppHelper.ValidateEmail(this.forgetModel.Email)) {
        this._alertService.showCustomMessage('Uyarı!', 'Lütfen geçerli bir e-mail adresi giriniz.', 'warning');
        return false;
      } else {
        this.loading = true;
        this.forgetModel.EmailCode = '';
        this.forgetModel.PasswordHashNew = '';
        this.forgetModel.PasswordHashNewAgain = '';
        this._userService.UserForgetPasswordEmailSend(this.forgetModel)
          .then(result => {
            var responseModel = (result || new ResponseModel()) as ResponseModel;
            this.loading = false;
            if (responseModel.Data) {
              // this.SendMailStatus += 1;
              this._alertService.showCustomMessage('Bilgi', 'Şifrenizi değiştirebileceğiniz link mail adresinize iletilmiştir. <br/> Linke tıklayarak şifre değiştirme adımlarını takip edebilirsiniz.', 'info');
              return true;
            }
            else {
              this._alertService.showCustomMessage('Uyarı!', 'Girmiş olduğunuz e-mail adresi bulunamamıştır.', 'warning');
              return false;
            }
          }).catch((ex: HttpErrorResponse) => {
            this._alertService.showCustomMessage('Hata!', 'Beklenmedik bir sorun ile karşılaşıldı. Lütfen daha sonra tekrar deneyin.', 'error');
            this.loading = false;
            return false;
          });
      }
    } else if (this.SendMailStatus === 1) {
      if (AppHelper.IsNullOrEmpty(this.forgetModel.EmailCode)) {
        this._alertService.showCustomMessage('Uyarı!', 'Kod alanını boş bırakılamaz.', 'warning');
        return false;
      }
      else if (AppHelper.IsNullOrEmpty(this.forgetModel.PasswordHashNew)) {
        this._alertService.showCustomMessage('Uyarı!', 'Yeni şifre alanını boş bırakılamaz.', 'warning');
        return false;
      }
      else if (AppHelper.IsNullOrEmpty(this.forgetModel.PasswordHashNewAgain)) {
        this._alertService.showCustomMessage('Uyarı!', 'Yeni şifre tekrar alanını boş bırakılamaz.', 'warning');
        return false;
      }
      else if (this.forgetModel.PasswordHashNew !== this.forgetModel.PasswordHashNewAgain) {
        this._alertService.showCustomMessage('Uyarı!', 'Yeni şifre ile yeni şifre tekrar alanını aynı olmalıdır.', 'warning');
        return false;
      }
      else {
        this.loading = true;
        this._userService.UserChangePassword(this.forgetModel)
          .then(result => {
            var responseModel = (result || new ResponseModel()) as ResponseModel;
            this.loading = false;
            this.SendMailStatus = 0;
            if (responseModel.Data) {
              this._alertService.showCustomMessage('Bilgi', 'Şifreniz başarılı bir şekilde değiştirilmiştir.', 'info');
              setTimeout(() => {
                this.cancelForget.nativeElement.click();
              }, 10)

              return true;
            }
            else {
              this._alertService.showCustomMessage('Uyarı!', 'Girmiş olduğunuz bilgiler yanlış olduğu için işlem yapılamadı.', 'warning');
              return false;
            }
          }).catch((ex: HttpErrorResponse) => {
            this._alertService.showCustomMessage('Hata!', 'Beklenmedik bir sorun ile karşılaşıldı. Lütfen daha sonra tekrar deneyin.', 'error');
            this.loading = false;
            this.SendMailStatus = 0;
            return false;
          });
      }
    }
  }

  GetReCaptcha() {
    this._authService.GetReCaptcha(JSON.parse(localStorage.getItem('Captcha')).CaptchaKey)
      .then(data => {
        const ReCaptcha = data as GetReCaptchaResponseModel;
        this.captchaCode = ReCaptcha.CaptchaImage;
        localStorage.setItem('Captcha', JSON.stringify({ 'CaptchaKey': ReCaptcha.CaptchaKey, 'captchaCode': this.captchaCode }));
      });
  }

  SecurityCodeCountdown() {
    let interval = setInterval(() => {
      this.counterInterval = this.counterInterval - 1;
      this.buttonText = "Kalan Süre : " + this.counterInterval;
      if (this.counterInterval === 0) {
        clearInterval(interval);
        this.buttonText = 'Tekrar Gönder';
        this.loading = false;
        this.counterInterval = 60;
      }
    }, 1000);
  }

  SecurityCodeForget() {
    this.model.code = null;
    this.signin();
  }

  OpenPasswordFields() {
    this.SendMailStatus = 0;

    LoginCustom.displayForgetPasswordForm();

    this.SendMailStatus = 1;
  }
}
